module.exports = __webpack_public_path__ + "static/media/b0_author.0423dd3a.mp3";